<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2c"><a id="page_v"></a>C<span class="small">ONTENTS</span></h2>
<p class="toc-entryb"><a href="#/xhtml/frontmatter01">Acknowledgments</a></p>
<p class="toc-entry"><a href="#/xhtml/frontmatter02">Introduction: Feminism, Front and Center</a></p>
<p class="toc-entrya"><em>Linda Beail and Lilly J. Goren</em></p>
<p class="toc-entry1"><a href="#/xhtml/part01"><strong>Part I: Feminism and the Idea and Constraints of Freedom</strong></a></p>
<p class="toc-entry"><a href="#/xhtml/part01chapter01#part01chapter01">1. <em>Extreme Makeover</em> and the Classical Logic of Transformation</a></p>
<p class="toc-entrya"><em>Emily Askew</em></p>
<p class="toc-entry"><span href="#/xhtml/part01chapter02#part01chapter02" title="Link target outside of Sample">2. Smart, Funny, and Romantic? Femininity and Feminist Gestures in Chick Flicks</span></p>
<p class="toc-entrya"><em>Laurie Naranch</em></p>
<p class="toc-entry"><span href="#/xhtml/part01chapter03#part01chapter03" title="Link target outside of Sample">3. From Madonna to Lilith and Back Again: Women, Feminists, and Pop Music in the United States</span></p>
<p class="toc-entrya"><em>Rachel Henry Currans-Sheehan</em></p>
<p class="toc-entry1"><span href="#/xhtml/part02" title="Link target outside of Sample"><strong>Part II: Housewives and Presidents: Cultural Understandings of Television Dramas</strong></span></p>
<p class="toc-entry"><span href="#/xhtml/part02chapter04#part02chapter04" title="Link target outside of Sample">4. The Reformer and Her Work: Transgression, Alienation, and Feminine Identity in the Police Procedural</span></p>
<p class="toc-entrya"><em>Peter Josephson and Rebecca Colton Josephson</em></p>
<p class="toc-entry"><span href="#/xhtml/part02chapter05#part02chapter05" title="Link target outside of Sample">5. The City, the Suburbs, and Stars Hollow: The Return of the Evening Soap Opera</span></p>
<p class="toc-entrya"><em>Linda Beail</em></p>
<p class="toc-entry"><span href="#/xhtml/part02chapter06#part02chapter06" title="Link target outside of Sample">6. Why Are All the Presidents Men? Televisual Presidents and Patriarchy</span></p>
<p class="toc-entrya"><em>Linda Horwitz and Holly Swyers</em></p>
<p class="toc-entry1"><span href="#/xhtml/part03" title="Link target outside of Sample"><strong>Part III: The Mommy Brigade</strong></span></p>
<p class="toc-entry"><span href="#/xhtml/part03chapter07#part03chapter07" title="Link target outside of Sample">7. Baby Lit: Feminist Response to the Cult of True Motherhood</span></p>
<p class="toc-entrya"><em>Melissa Buis Michaux and Leslie Dunlap</em></p>
<p class="toc-entry"><span href="#/xhtml/part03chapter08#part03chapter08" title="Link target outside of Sample">8. Supermom: The Age of the Pregnant Assassin</span></p>
<p class="toc-entrya"><em>Lilly J. Goren</em></p>
<p class="toc-entry"><span href="#/xhtml/part03chapter09#part03chapter09" title="Link target outside of Sample">9. The Mommy Track versus Having It All: The Reality of the Modern Workplace</span></p>
<p class="toc-entrya"><em>Julia Wilson</em></p>
<p class="toc-entry1"><a id="page_vi"></a><span href="#/xhtml/part04" title="Link target outside of Sample"><strong>Part IV: What Do Women Want?</strong></span></p>
<p class="toc-entry"><span href="#/xhtml/part04chapter10#part04chapter10" title="Link target outside of Sample">10. It Was Chick Lit All Along: The Gendering of a Genre</span></p>
<p class="toc-entrya"><em>Cecilia Konchar Farr</em></p>
<p class="toc-entry"><span href="#/xhtml/part04chapter11#part04chapter11" title="Link target outside of Sample">11. The Personal Is Political: Women’s Magazines for the “I’m-Not-a-Feminist-But” Generation</span></p>
<p class="toc-entrya"><em>Natalie Fuehrer Taylor</em></p>
<p class="toc-entry"><span href="#/xhtml/part04chapter12#part04chapter12" title="Link target outside of Sample">12. The Money, Honey: The Rise of the Female Anchor, the Female Reporter, and Women in the News Business</span></p>
<p class="toc-entrya"><em>Mary McHugh</em></p>
<p class="nospace"> </p>
<p class="toc-entry"><span href="#/xhtml/backmatter01" title="Link target outside of Sample">Selected Bibliography</span></p>
<p class="toc-entry"><span href="#/xhtml/backmatter02" title="Link target outside of Sample">List of Contributors</span></p>
<p class="toc-entry"><span href="#/xhtml/backmatter03" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?60466e06